import { Page } from "src/app/core/models/page";
import { SortOrder } from 'src/app/core/interface/sort-order';

export class DOAbnormalTableAbnormalItemGetRequest extends Page {
  moNo: string;
  moItemSeqNo: number | null;
  sortOrder: SortOrder | null;

  constructor() {
    super();
    this.moNo = '';
    this.moItemSeqNo = null;
    this.sortOrder = null;
  }
}
